import { ApiResponse, Meta, TicketManagerAssignableUser, TicketManagerTicketDetail } from '@vision/ui/interfaces';
import { normalizeTicketManagerTicketDetail, TicketManagerTicketDetailApi } from '../../ticket-manager.service.utils';

export interface TicketManagerAssignableUserNestedResponseDto {
  email?: string;
  full_name?: string;
  id?: string;
  name?: string;
  surname?: string;
}

export interface TicketManagerAssignableUserResponseDto {
  email?: string;
  full_name?: string;
  id: string;
  name?: string;
  surname?: string;
  user?: TicketManagerAssignableUserNestedResponseDto | null;
}

export interface TicketManagerAssignableUserResponseEnvelope {
  data: TicketManagerAssignableUserResponseDto[];
  meta?: ApiResponse<TicketManagerAssignableUserResponseDto[]>['meta'];
  object: 'object' | 'collection';
  url?: string;
}

export interface TicketManagerTicketDetailResponseEnvelope {
  data: TicketManagerTicketDetailApi;
  meta?: ApiResponse<TicketManagerTicketDetailApi>['meta'];
  object: 'object' | 'collection';
  url?: string;
}

function resolveUserSource(dto: TicketManagerAssignableUserResponseDto): TicketManagerAssignableUserNestedResponseDto {
  if (dto.user !== undefined && dto.user !== null) {
    return dto.user;
  }

  return dto;
}

function resolveFullName(user: TicketManagerAssignableUserNestedResponseDto): string {
  if (user.full_name) {
    return user.full_name;
  }

  const combined = [user.name, user.surname].filter(Boolean).join(' ');

  if (combined) {
    return combined;
  }

  return user.email || '';
}

function mapAssignableUserItem(dto: TicketManagerAssignableUserResponseDto): TicketManagerAssignableUser {
  const user = resolveUserSource(dto);

  return {
    email: user.email || '',
    fullName: resolveFullName(user),
    id: user.id || dto.id,
    name: user.name || '',
    surname: user.surname || '',
  };
}

export function normalizeTicketManagerAssignableUsersResponse(
  response: TicketManagerAssignableUserResponseEnvelope,
): ApiResponse<TicketManagerAssignableUser[]> {
  return {
    data: response.data.map(mapAssignableUserItem),
    meta: response.meta ?? null,
    object: response.object,
    url: response.url,
  };
}

export function normalizeTicketManagerTicketDetailResponse(
  response: TicketManagerTicketDetailResponseEnvelope,
): ApiResponse<TicketManagerTicketDetail, Meta> {
  return {
    data: normalizeTicketManagerTicketDetail(response.data),
    meta: response.meta ?? null,
    object: 'object',
    url: response.url,
  };
}
